<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M16 29.333c7.364 0 13.334-5.97 13.334-13.334 0-7.363-5.97-13.333-13.334-13.333-7.363 0-13.333 5.97-13.333 13.333 0 7.364 5.97 13.334 13.333 13.334zm-1.666-12.834c0 .19.052.367.144.518a.99.99 0 00.23.356l4.478 4.479a1 1 0 001.414-1.415l-4.266-4.266v-6.005a1 1 0 00-2 0v6.333z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'objectsClockFilled'
}
</script>
